import React, { useCallback, useMemo, useState } from "react";
import { Document, Page } from "react-pdf";

interface Props {
    href: string;
}
export function DocumentPdf({ href }: Props) {
    const [numPages, setNumPages] = useState<number | null>(null);

    const handleLoadedDocument = useCallback(
        ({ numPages }: { numPages: any }
        ) => {
            setNumPages(numPages);
        }, []);

    return useMemo(() => (
        <Document
            file={{ url: href }}
            onLoadSuccess={handleLoadedDocument}
        >
            {Array.apply(null, Array(numPages))
                .map((x, i) => i + 1)
                .map((page) => (
                    <Page
                        key={page}
                        pageNumber={page}
                        width={800}
                        renderAnnotationLayer={false}
                        renderTextLayer={false}
                    />
                ))}
        </Document>
    ), [numPages, handleLoadedDocument, href]);
}